import { ArrowLeftIcon } from '@radix-ui/react-icons';
import { Box, Flex } from '@workos-inc/design-system';
import * as React from 'react';
import { Link } from './link';
export const Breadcrumb = ({
  href,
  children
}: React.ComponentPropsWithoutRef<typeof Link>) => <Box mb="2" data-sentry-element="Box" data-sentry-component="Breadcrumb" data-sentry-source-file="breadcrumb.tsx">
    <Flex asChild align="center" display="inline-flex" gap="1" data-sentry-element="Flex" data-sentry-source-file="breadcrumb.tsx">
      <Link color="gray" href={href} m="-2" size="2" style={{
      padding: 'var(--space-2)'
    }} data-sentry-element="Link" data-sentry-source-file="breadcrumb.tsx">
        <ArrowLeftIcon height="16" width="16" data-sentry-element="ArrowLeftIcon" data-sentry-source-file="breadcrumb.tsx" />
        {children}
      </Link>
    </Flex>
  </Box>;